var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioIconDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0C41.136 0 53 11.864 53 26.5S41.136 53 26.5 53 0 41.136 0 26.5 11.864 0 26.5 0",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.776 16c1.9 0 3.5 1.6 3.5 3.5v6c0 1.9-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5v-6c0-1.9 1.6-3.5 3.5-3.5",
    fill: "#3C4C60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.476 25.4c.5 3.6 2.3 5.3 5.4 5.2 3-.1 4.8-1.8 5.2-5.2.1-.5.5-.9 1-.9h.6c.6 0 1 .4 1 1v.1c-.5 5.1-3.1 7.7-7.8 7.7-4.7 0-7.3-2.6-7.8-7.7-.1-.5.4-1 .9-1.1h.5c.5 0 1 .4 1 .9m1.3 9.1h8.6c.7 0 1.2.5 1.2 1.2v.6c0 .7-.5 1.2-1.2 1.2h-8.6c-.7 0-1.2-.5-1.2-1.2v-.6c0-.7.5-1.2 1.2-1.2",
    fill: "#3C4C60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.576 15.5l19 18.8c.5.4.5 1.2 0 1.6-.5.4-1.2.4-1.7 0l-19-18.7c-.5-.5-.5-1.2 0-1.6l.1-.1.1-.1c.4-.3 1.1-.3 1.5.1",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.876 16.3l19.899 19.5c.401.4.401 1 0 1.3-.399.4-1 .4-1.399 0l-20-19.5c-.4-.3-.4-.9 0-1.3h.1c.4-.4 1-.4 1.4 0",
    fill: "#3C4C60"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIconDisabled);
export default __webpack_public_path__ + "static/media/AudioIconDisabled.1454a7a63de1641d5485ea7da615429e.svg";
export { ForwardRef as ReactComponent };